import React, { useEffect, useMemo, useState } from "react";
import { formatNumberToCurrency } from "@utils/formatNumber";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import DetailsAccordion from "../advancements/DetailsAccordion";
import MultipleAdvanceForm from "../advancements/MultipleAdvanceForm";
import LoaderItem from "../value/accordion/LoaderItem";
import DetailsGraph from "../advancements/DetailsGraph";

const NewDataHandler = ({ max, from, name, wbs }) => {
  const { updateAdvancement } = useProjectActions()
  const { activeProject } = useProjectContext()
  const [newData, setNewData] = useState({
    max: max,
    from: from,
    value: '',
    to: '',
    description: '',
  })
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState({
    code: 0,
    msg: ''
  })

  const formatCurrency = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    const numericValue = parseFloat(cleanedValue) / 100;
    if (numericValue > max) {
      return max.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    if (inputValue.length === 0) {
      setNewData(prev => ({ ...prev, value: "" }));
    } else {
      setNewData(prev => ({ ...prev, value: formatCurrency(inputValue) }));
    }
  };

  const handleSend = async () => {
    // if (!newData.value) return 0;
    const cleanedString = newData.value
      .replace(/[R$.\s]/g, "")
      .replace(",", ".");
    const numericValue = parseFloat(cleanedString);
    const { description, to, from } = newData
    setLoading(true)
    const res = await updateAdvancement({
      operation: 'create',
      name,
      value: numericValue,
      description,
      to,
      from,
      wbs,
    })
    setResponse(res)
    setLoading(false)
  }

  const handleToChange = (e) => {
    const { value } = e.target
    setNewData(prev => ({ ...prev, to: `${value.slice(5, 7)}/${value.slice(0, 4)}` }))
  }

  const handleDescChange = (e) => {
    setNewData(prev => ({ ...prev, description: e.target.value }))
  }

  const checkDisabled = () => {
    return (newData.value === '' || newData.to === '' || loading)
  }


  return <>
    <p>Adiantar valores do mês {from}:</p>
    <div className="advancement-form-container">
      <div>
        <p>Selecione o valor que deseja adiantar:</p>
        <input
          className="resource-search"
          type="text"
          max={newData.max}
          value={newData.value}
          onChange={handleInputChange}
          placeholder={`Máx.: ${formatNumberToCurrency(newData.max)}`}
        />
      </div>
      <div>
        <p>Selecione o mês para o qual deseja adiantar:</p>
        <input className="resource-search" type='month' onChange={handleToChange} />
      </div>
      <div>
        <p>Descrição da antecipação (Opcional): </p>
        <input className="resource-search" type='text' onChange={handleDescChange} />
      </div>
    </div>
    <div className="flex direction-column justify-content-end">
      <button className={`button button-${checkDisabled() ? 'grey' : 'accent'} margin-bottom-16 margin-top-8`} disabled={checkDisabled()} onClick={handleSend}>Enviar</button>
      {response.code === 200 && <p style={{ textAlign: 'end' }}>Antecipação criada!</p>}
      {response.code === 500 && <p style={{ textAlign: 'end' }}>Erro, tente novamente</p>}
    </div>
  </>
}

const TableMonthAdvancements = () => {
  const { selectedDetail: { item }, activeProject, projectionTable, tableMonthSelected } = useProjectContext();
  const [toggle, setToggle] = useState(false)
  const { getAppropriation, getAdvancements, updateAdvancement } = useProjectActions();
  const [items, setItems] = useState([])
  const [status, setStatus] = useState({
    finished: false,
    searched: false
  })
  const [groupedMonths, setGroupedMonths] = useState([])
  const [transferData, setTransferData] = useState({
    from: '',
    to: '',
    max: 0,
    amount: 0
  })
  const [advancements, setAdvancements] = useState([])
  const [simple, setSimple] = useState(true)

  useEffect(() => {
    if (projectionTable && window.location.pathname.includes('projecao-financeira')) {
      getItems()
      setToggle(false)
    }
  }, [item, activeProject, tableMonthSelected])

  const getItems = async () => {
    setStatus({ ...status, searched: true });
    const response = await getAppropriation(activeProject?.appropriation_level, item.wbs_code_id)
    const adv = await getAdvancements(activeProject.building_id, item.wbs_code_id)
    setAdvancements(Array.isArray(adv?.response) ? [...adv.response] : []);
    setItems(Array.isArray(response?.items) ? [...response.items] : []);
    setStatus(prev => { return { ...prev, finished: true } })
    let months = [];
    if (Array.isArray(response?.items)) {
      response.items.forEach(i => {
        i.disbursements.forEach(j => {
          const idx = months.findIndex(k => k.year === j.year && k.month === j.month);
          if (idx === -1) {
            months.push({ ...j });
          } else {
            months[idx].value += j.value;
          }
        });
      });
    }
    months.sort((a, b) => {
      if (a.year !== b.year) {
        return a.year - b.year;
      } else {
        return a.month - b.month;
      }
    });
    setGroupedMonths(months)
  }


  const handleSelectMonth = (event, itemsClicked) => {
    if (!event.chart.tooltip.dataPoints) return
    if (itemsClicked) {
      const { label, raw: maxValue } = event.chart.tooltip.dataPoints[0]
      setTransferData(prev => { return { ...prev, from: label, max: maxValue } })
    }
  }

  const memoizedGraph = useMemo(() => (
    <DetailsGraph data={groupedMonths} onClick={handleSelectMonth} />
  ), [groupedMonths]);

  const handleDelete = async (entry) => {
    const response = await updateAdvancement({
      operation: 'remove',
      wbs: item.wbs_code_id,
      ...(entry.entryId ? { entryId: entry.entryId } : {}),
      from: entry.from,
      to: entry.to,
    })
    if (response?.code === 200) {
      const refreshed = await getAdvancements(activeProject.building_id, item.wbs_code_id)
      setAdvancements(Array.isArray(refreshed?.response) ? [...refreshed.response] : [])
    }
  };


  const Item = ({ item }) => {
    return <div key={item.creditor_name}>
      <div className="margin-bottom-8 flex align-center">
        <button
          className={`accordion-toggle ${toggle ? "active" : ""}`}
          onClick={() => setToggle(!toggle)}
        />
        <span style={{ fontWeight: "bold", fontSize: '22px' }}>Antecipações</span>
      </div>
      {toggle &&
        <div className="margin-left-16 advancement-infos-container">
          {(status?.searched && status?.finished && items?.length === 0) && <p>Sem datas para antecipação</p>}
          {(items?.length === 0 && status?.searched && !status.finished) && <LoaderItem />}
          {Array.isArray(advancements[0]?.data) && advancements[0].data.length > 0 && advancements[0].data.map((i) => {
            return <div className="existing-advancements" style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr' }} key={i.entryId || `${i.from}-${i.to}-${i.value}-${i.updated_at || ''}`}>
              <div>
                <p style={{ marginTop: '0px' }} className="label">Valor:</p>
                <p style={{ marginTop: '0px' }} className="value">{formatNumberToCurrency(i.value)}</p>
              </div>
              <div>
                <p style={{ marginTop: '0px' }} className="label">Do mês:</p>
                <p style={{ marginTop: '0px' }} className="value">{i.from}</p>
              </div>
              <div>
                <p style={{ marginTop: '0px' }} className="label">Para o mês:</p>
                <p style={{ marginTop: '0px' }} className="value">{i.to}</p>
              </div>
              <div>
                <p style={{ marginTop: '0px' }} className="label">Descrição</p>
                <p style={{ marginTop: '0px' }} className="value">{i.description}</p>
              </div>
              <button style={{ justifyContent: 'center' }} onClick={() => handleDelete(i)}>Deletar</button>
            </div>
          })}
          {(status?.searched && status?.finished && items?.length > 0) && <div className="advancement-type-container margin-top-8">
            <h2 className={simple && 'active'} onClick={() => setSimple(true)}>Antecipação Simples</h2>
            <h2 className={!simple && 'active'} onClick={() => setSimple(false)}>Antecipação Múltipla</h2>
          </div>}
          {(items?.length > 0) && <div>
            <div style={{ height: '250px', maxWidth: '85vw' }}>
              {memoizedGraph}
            </div>
            {(simple && transferData.from !== '') && <NewDataHandler max={transferData.max} from={transferData.from} name={item.description} wbs={item.wbs_code_id} />}
            {(!simple && <MultipleAdvanceForm months={groupedMonths} item={item} />)}
            <p>Distribuição por insumo/mês:</p>
            <div className="advancement-items" style={{ maxWidth: "230px" }}>
              {items?.map(i => {
                return <DetailsAccordion item={i} />
              })}
            </div>
          </div>}
        </div>
      }
    </div>
  }

  return <Item item={item} />
}

export default TableMonthAdvancements;
